import { AgentSurfacePlaceholder } from "@/pages/agent/components/agent-surface-placeholder";

interface AgentActivityPageProps {
  activityId: string;
}

export const AgentActivityPage = ({ activityId }: AgentActivityPageProps) => {
  return (
    <AgentSurfacePlaceholder
      eyebrow="Activity"
      title={`Activity ${activityId}`}
      description="Activity detail content will live here."
    />
  );
};
